export default __webpack_public_path__ + "static/media/product20.927298f0.png";